import DocumentVault from './DocumentVault'

export default DocumentVault
